export const GENERAL = {
  GMAP_API_KEY: "AIzaSyDv-NdCjT75Fnb96OlGFBvZbKnYb0oNr08",
  GMAP_MAP_ID: "53f50046625539f6",
};

// Centro por defecto del mapa por país (lat/lng) + zoom inicial.
// Fuente única para cualquier consumidor de Google Maps que necesite un centro
// cuando no hay coordenada propia. NOTA: Mapa/index.js todavía tiene su copia local
// del literal (no se migró en Bloque C Fase 2 para no tocar /mapa); de-dup pendiente.
export const CENTROS_MAPA_POR_PAIS = {
  Chile: { lat: -33.41305, lng: -70.60635 },
  Perú: { lat: -12.10979, lng: -77.01751 },
  Uruguay: { lat: -34.89434, lng: -56.15867 },
};

// Fallback cuando el país no matchea (mismo criterio que Mapa: cae a Perú).
export const CENTRO_MAPA_DEFAULT = CENTROS_MAPA_POR_PAIS["Perú"];

// Zoom inicial estándar del mapa (mismo valor que /mapa).
export const ZOOM_MAPA_DEFAULT = 13.5;
